<template>
  <div id="admin-list"
       class="flex flex-col flex-1 min-h-0 pt-2 overflow-hidden"
  >
    <side-list :items="items"
               :selected-id="selectedLabel"
               id-key="label"
               class="h-full min-h-0"
    >
      <template #item="{ item, isItemSelected }">
        <settings-list-item :is-selected="isItemSelected"
                            :label="item.label"
                            :route="item.route"
                            :icon="item.icon"
        />
      </template>
    </side-list>
  </div>
</template>

<script>
import SettingsListItem from '@/components/settings/SettingsListItem.vue'
import SideList from '@/components/common/SideList.vue'
import { ROUTE_NAMES } from '@/router'

const ADMIN_NAV_ITEMS = [
  { label: 'Indexation Overview', route: ROUTE_NAMES.adminIndexations, icon: 'reindex-icon' },
  { label: 'Vector Collections', route: ROUTE_NAMES.adminVectorCollections, icon: 'GPT-icon' },
  { label: 'Organizations', route: ROUTE_NAMES.adminOrganizations, icon: 'admin-icon' }
]

export function getAdminSectionTitle(routeName) {
  const item = ADMIN_NAV_ITEMS.find(item => item.route === routeName)
  return item ? item.label : 'Indexation Overview'
}

export default {
  name: 'AdminList',

  components: { SideList, SettingsListItem },

  computed: {
    selectedLabel() {
      return getAdminSectionTitle(this.$route.name)
    },
    items() {
      return ADMIN_NAV_ITEMS
    }
  }
}
</script>

<style lang="scss">
#admin-list {
  .vb-dragger {
    @apply hidden invisible;
  }

  @apply p-1 pb-4;

  .side-list {
    @apply pb-2;
  }

  .side-list ul {
    @apply pb-8;
  }

  a {
    @apply text-gray-dark;
  }
}
</style>
